import * as React from 'react';
import * as InfiniteScroll from 'react-infinite-scroller';

import { LoaderBlock } from 'components/Loader';

import './Infinite.scss';

interface InfiniteProps {
  className?: string;
  loadMore?: VoidFunction;
  hasMore?: boolean;
  isLoading?: boolean;
}

export class Infinite extends React.Component<InfiniteProps, {}> {
  constructor(props: InfiniteProps) {
    super(props);

    this.next = this.next.bind(this);
  }

  render() {
    const { className, hasMore } = this.props;
    return (
      <InfiniteScroll
        className={className}
        hasMore={hasMore}
        loadMore={this.next}
        loader={this.loader}
        useWindow={true}
        threshold={100}
      >
        {this.props.children ? this.props.children : this.loader}
      </InfiniteScroll>
    );
  }

  get loader() {
    return (
      <div className="infinite__loader">
        <LoaderBlock blocking={true} />
      </div>
    );
  }

  private next() {
    const noop = () => null;
    const { loadMore = noop , hasMore, isLoading } = this.props;
    if (!isLoading && hasMore) {
      loadMore();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Infinite/Infinite.tsx